<template>
  <div v-if="sidebar">
    <BaseContainer>
      <div :class="className">
        <slot></slot>
      </div>
    </BaseContainer>
  </div>
  <div v-else>
    <div class="page" :class="classModal">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import BaseContainer from './BaseContainer.vue'
export default {
  name: 'PageGrid',
  components: { BaseContainer },
  props: {
    sidebar: {
      type: Boolean,
      default: false
    },
    modal: {
      type: Boolean,
      default: false
    },
    sharetools: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    className() {
      return `page page--sidebar ${(this.sharetools && 'page--sharetools') ||
        ''}`
    },
    classModal() {
      return `${(this.modal && 'modal') || ''}`
    }
  }
}
</script>


<style lang="postcss">
.page {
  @apply flex;
}
.page--sidebar {
  @apply my-8;
}
@screen lg {
  .page {
    @apply relative;
  }
  .page--sidebar {
    @apply -mx-4 my-12;
  }
}
</style>
